export default "__VITE_ASSET__CuBh$4sg__"